import styled from 'styled-components';
import { ThemeType } from '../../../../types/Theme';

const ModaisConfigContainer = styled.div<{theme: ThemeType}>`
    .bloqueado-container {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 3rem;
        margin: 2rem 0;
    }

    .botoes{
        display: flex;
        align-items: center;
        gap: 2rem;
        justify-content: space-between;
        .arrow{
            display: flex;
            cursor: pointer;
            align-items: center;
            gap: 1rem;
            svg{
                margin-top: 2px;
                stroke: ${props => props.theme.colors.tertiary};
            }
        }
    }
`;

export { 
    ModaisConfigContainer,
};